// extracted by mini-css-extract-plugin
export default {"container":"FullHeightCard_container__tLTyK","contentContainer":"FullHeightCard_contentContainer__cUDY2","body":"FullHeightCard_body__uI20X"};